<template>
    <v-layout d-flex>
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">                                                         
            <v-layout column>
                <v-flex class="dropbox" v-if="!uploading && !fileData">    
                    <v-layout column justify-center align-center mt-5>
                        <i class="material-icons" style="font-size:50px">file_upload</i>
                        <v-flex>                                                    
                            Sleep een bestand hierheen 
                        </v-flex>
                        <v-flex>
                            of klik om te browsen
                        </v-flex>
                    </v-layout>            
                </v-flex>                
            </v-layout>                            
            <v-flex d-flex class="input-upload-flex">
                <input v-if="fileActive" class="d-flex input-upload-file" type="file" ref="fileUploadInput"  multiple @change="fileSelected" :disabled="isSaving" >                        
            </v-flex>
            <v-layout>
                <v-flex v-if="!uploading && fileData">
                    <v-flex style="z-index: 200;">
                        <v-layout column justify-space-between>
                            <v-flex mt-4 ml-4>
                                Bestand <strong>{{ fileData.name}} </strong> ({{ fileData.size | humanFileSize}}) klaar om te uploaden...       
                            </v-flex>                                 
                            <v-flex d-flex row mt-2>
                                <v-btn  @click="fileData=null; clearState()" >annuleren</v-btn>                            
                                <v-btn color="accent" @click="startUpload" >uploaden</v-btn>
                            </v-flex>                                                    
                        </v-layout>                
                    </v-flex>              
                </v-flex>                
            </v-layout>

            <v-flex v-if="uploading">
                Bezig met uploaden...
                <v-progress-linear
                    v-model="uploadPercentage"
                    :active="true"
                    :indeterminate="(uploadPercentage == 0 || uploadSpeed == 'Infinity')"
                    :query="true"
                    color="accent"
                    height="18"
                ></v-progress-linear>
                
                <span v-if="uploadPercentage == 0">Bezig met het maken van verbinding...</span>
                <!-- <span v-else>{{ uploadPercentage }}% voltooid</span>                                                                                                                 -->
                <span v-if="uploadSpeed > 0 && uploadSpeed != 'Infinity'">{{ uploadSpeed | humanFileSize }}/s</span>
                <span v-else></span>
            </v-flex>
        </form>
    </v-layout>
</template>
<script>
    import axios from 'axios'
    import { mapGetters } from "vuex";
    import * as types from "../../store/types";
    import { CKEY } from "../../config"

    export default{
        props:{
            url:{
                type: String,
                required: true
            },
            blockUI: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                fileActive:true,
                selectedFile:null,
                isSaving: false,
                isInitial: true,
                uploading: false,
                uploadPercentage: 0,
                uploadSpeed: '',            
                fileData: '',  
            }
        },
        computed: {
            ...mapGetters({                
                accessToken: types.USER_ACCESS_TOKEN
            })
        },
        methods:{
            uploadIsDone(res){
                this.$emit('uploadDone', res)
            },
            fileSelected(){
                if(this.$refs.fileUploadInput.files && this.$refs.fileUploadInput.files.length > 0) {
                    this.fileData = this.$refs.fileUploadInput.files[0]
                }
            },
            clearState(){
                // reload file input to make sure it is empty for next upload (else @change wont trigger)
                this.fileActive=false;
                this.$nextTick( () => {
                    this.fileActive=true
                })
                this.uploading = false;
                this.uploadSpeed = '';
                this.uploadPercentage = '';
                this.fileData = '';
            },
            startUpload(){
                
                    let xferStart = Math.floor(Date.now() / 1000)
                    this.uploading = true;
                    const fd = new FormData();                    

                    fd.append('file', this.fileData)

                    let vm = this;
                    axios.post(this.url, fd, {
                        headers:{
                            'X-Tenant': CKEY,
                            'X-Localization': 'nl',
                            Authorization: `Bearer ${this.accessToken}`
                        },                    
                        onUploadProgress: function (progressEvent) {
                            if(progressEvent.lengthComputable) {
                                vm.uploadSpeed = progressEvent.loaded / (Math.floor(Date.now()/1000) - xferStart).toFixed(1)
                                vm.uploadPercentage = parseInt((progressEvent.loaded / progressEvent.total) * 100)

                                vm.$emit('isUploading', { progressEvent: progressEvent, uploadSpeed:vm.uploadSpeed, uploadPercentage: vm.uploadPercentage })
                            }                            
                        }
                    }).then((res) => {                                        
                        vm.uploadIsDone(res.data.data)
                        vm.clearState()                        
                    }).catch((error) => {
                        vm.clearState()
                        if(error.response.status == 413){
                            vm.$notify('Fout bij upload: bestand is te groot', {type: 'error', icon:'exclamation'})
                        }
                        else{
                            vm.$notify('Fout bij uploaden', {type: 'error', icon:'exclamation'})
                        }
                    })                
            }
        },
        mounted(){
            this.clearState();            
        }
    }
</script>
<style>
 .file-upload-holder{
        display:flex;
        text-align: center;    
        justify-content: center !important;
        align-content: center !important;
        align-items: center !important;        
    }

   .input-upload-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        background-color: red;
        height: 200px !important;
        
        cursor: pointer;
        z-index:100;
  }

  .dropbox {
    outline: 3px dashed #ccc; /* the dash box */
    outline-offset: -10px;
    background-color: #fff;
    
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    
    cursor: pointer;
    border-radius: 8px;
    transition: visibility 0s, opacity 0.5s linear;
    width:100%;
  }

  .input-upload-flex{
      flex: 1,1;
      margin-top: -200px !important;
  }

  .upload-percentage-label{
      
      margin-top: -33px;
      z-index: 700;
      text-align: center;
      font-weight: 600;


  }
</style>

